<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="addressModal" ref="modal">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header p-bottom-0">
          <button v-if="mayClose" type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title" style="padding-top: 35px;margin-bottom: -35px;">Adressenboek</h4>
          <div class="pull-right">
            <form class="form-inline" @submit.prevent="getLocations">
              <div class="form-group">
                <label for="term" class="m-right-10">Zoeken</label>
                <input type="text" class="form-control" id="term" v-model="locationFields.term">
              </div>

              <button type="submit" class="btn btn-primary">Zoek contact</button>
              <button type="button" class="btn btn-default" v-if="this.locationFields.term" @click="clearLocationSearch">Toon alles</button>
            </form>

          </div>
        </div>
        <div class="modal-body">

          <div v-if="locations.data.length" class="table-responsive loaderui" v-bind:class="{ 'loaderui-loaded' : !loading }">
            <table class="table table-hover">
              <thead>
              <tr>
                <th>Bedrijf</th>
                <th>Adres</th>
                <th>Contact</th>
                <th>Tel. nr. contactpersoon</th>
                <th>E-mailadres contactpersoon</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="location in locations.data"
                  :key="location.id"
                  class="c-p"
                  @click="selectLocation(location)"
              >
                <td>{{ location.name }}</td>
                <td>{{ location.street }} {{ location.number }} {{ location.number_suffix }}<br>{{ location.postcode }} {{ location.city }}<br></td>
                <td>{{ location.contact }}</td>
                <td>{{ location.contact_telephone }}</td>
                <td>{{ location.contact_email }}</td>
                <td class="text-right">
                  <button
                      type="button"
                      class="btn btn-xs btn-primary"
                      @click="selectLocation(location)"
                  >
                    Kies contact
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <p v-else-if="loading">Bezig met laden...</p>

          <p v-else>Er zijn geen locaties gevonden.</p>

          <div class="text-center">
            <vue-pagination
                :pagination="locations"
                @paginate="getLocations()"
                :offset="10">
            </vue-pagination>
          </div>
        </div>
        <div class="modal-footer" v-if="mayClose" >
          <button type="button" class="btn btn-default" data-dismiss="modal">Sluit</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppAddressBookModal",

  props: {
    companyId: {
      type: [Number, String],
      default: '',
    },

    closable: {
      type: Boolean,
      default: true,
    },

    compound: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      searching: false,
      loading: false,
      locations: {
        total: 0,
        per_page: 2,
        from: 1,
        to: 0,
        current_page: 1,
        data: []
      },
      locationFields: {
        term: ''
      },
    }
  },

  mounted() {
    this.getLocations();

    jQuery(this.$refs.modal).modal({
      keyboard: false,
      backdrop: 'static',
    }).on('hidden.bs.modal', () => {
      this.$emit('close');
    });
  },

  computed: {
    mayClose() {
      if (! this.loading && this.locations.data.length < 1) {
        return true;
      }

      return this.closable;
    }
  },

  methods: {
    getLocations: function() {
      this.loading = true;
      this.searching = true;

      let url = `/ritten/locaties?page=${this.locations.current_page}`
      if (this.companyId) {
        url = `/ritten/locaties/${this.companyId}?page=${this.locations.current_page}`
      }

      url = url + '&compound=' + this.compound;

      this.$http.post(url, this.locationFields).then(response => {
        this.locations = response.data;
        this.loading = false;

        if (this.locationFields.term) {
          this.searching = false;
        }
      });
    },

    clearLocationSearch: function() {
      this.locationFields.term = '';
      this.getLocations();
    },

    selectLocation: function(location) {
      jQuery(this.$refs.modal).modal().hide();
      this.$emit('select', location);
    },
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/AppAddressBookModal.vue